import localforage from "localforage";

export enum ExplorerEnvironment {
  NBA = "nba",
  DRAFT = "draft",
}

export enum CacheKey {
  Filters = "filters",
  Metrics = "metrics",
  Queries = "queries",
  Teams = "teams",
  Glossary = "glossary",
}

const getEnvironmentKey = (key: CacheKey, env: ExplorerEnvironment) =>
  `${env}_${key}`;

export const writeToCache = (
  key: CacheKey,
  data: any,
  env: ExplorerEnvironment
) => {
  try {
    localforage.setItem(getEnvironmentKey(key, env), data);
  } catch (e) {
    console.log("error writing to cache: ", e);
  }
};

export const readFromCache = async (
  key: CacheKey,
  env: ExplorerEnvironment
) => {
  try {
    const data = await localforage.getItem(getEnvironmentKey(key, env));
    return data;
  } catch (e) {
    console.log("error reading from cache: ", e);
    return null;
  }
};

export const clearCache = async (key: CacheKey, env: ExplorerEnvironment) => {
  try {
    await localforage.removeItem(getEnvironmentKey(key, env));
  } catch (e) {
    console.log("error clearing cache: ", e);
  }
};
